import { useSnapshot } from "valtio"
import { chargesBookingValidationStore } from "../mybooksv3/booking-commonstate.js"
import { AgmodalStore, cargoStore, configStore, contractsStore } from "../state/CommonState.js";
import { useEffect, useMemo, useState } from "react";
import Utils from "../util/Utils.js";
import { Card } from "../v3-componets/AgCard.js"
import { Headspan } from "../v3-componets/AgHeadspan.js"
import { chargesData1 } from "../StaticData.js";
import QuoteCalcV2 from "../util/quote-calc-v2.js";
import { loader } from "../util/loader.js";
import Api from "../state/Api.js";
import { editrequestapprovalStore } from "./editrequestapprovalStore.js";
import RoleUtils from "../util/RoleUtils.js";
import { PERMISSIONS_NEW } from "../util/constants.js";
import TenantUtils from "../util/tenant.utils.js";
import { LCLChargesCompFrom } from "../quick-quotev3/editchargenew.js";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { AgSelectNewCH } from "../components/AgCustlist.js";
import isEqual from 'lodash/isEqual.js';
import LabeledTextField from "../mui-components/LabeledTextField.js";
import { AgCustomFile } from "../components/AgFile.js";
import MonApi from "../state/mongo-api.js";
import { loadAiHistory, getAiHistory } from "../components/AiChargeParse.js";

export default function EditRequestApproveCharge(props) {
    let setOpenChargeModel = props.setOpenChargeModel
    useSnapshot(contractsStore)
    useSnapshot(editrequestapprovalStore)
    // AI charge history of this rate request: loaded per request #, saved with the approval (save below)
    const aiHistoryKey = editrequestapprovalStore.quote?._id || ""
    useEffect(() => { loadAiHistory("rateRequestApproval", aiHistoryKey, editrequestapprovalStore.quote?.quoteData?.aiChargeHistory) }, [aiHistoryKey])
    const [originallist,setOriginallist] = useState([])
    const [originalrebatelist,setOriginalrebatelist] = useState([])
    const [originalpkblist,setOriginalpkblist] = useState([])
    const [tlimits,setTlimits] = useState([])
    const [errors,setErrors] = useState([])
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const [actionmodal, setActionmodal] = useState(false)
    const [editload, setEditload] = useState(false)
    const [conditions,setConditions] = useState([])
    const [remarks,setRemarks] = useState("")
    // Costs fetched with "Get Cost"; kept off the store quote so the form is not re-initialised
    const [fetchedCostRecords, setFetchedCostRecords] = useState(null)
    const [costLoading, setCostLoading] = useState(false)
    const filecat = '' + Date.now()
    const charges = useForm({
        defaultValues:{
            groupedByCategory:{},
            rebate:[],
            pkb:[],
            list:[],
            originallistlist:[],
            originallistrebate:[],
            originallistpkb:[],
            costrecord:[],
            initialLength:0,
            initialLength1:1,
            initialLength2:4,
            containerType:20,
            loadibility:0,
            editload:false,
            cbm:0,
            totalweight:0
        }
    })
    const { control, setValue,watch } = charges;
    const formValues = watch();
    const watchedList = useWatch({
        control,
        name: 'list',
    });

    const watchedRebate = useWatch({
        control,
        name: 'rebate',
    });

    const watchedPkb = useWatch({
        control,
        name: 'pkb',
    });
    const watchedoriginalList = useWatch({
        control,
        name: 'originallistlist',
    });

    const watchedoriginalRebate = useWatch({
        control,
        name: 'originallistrebate',
    });

    const watchedoriginalPkb = useWatch({
        control,
        name: 'originallistpkb',
    });
    const watchedcostrecord = useWatch({
        control,
        name: 'costrecord',
    });
    const containerType = watch("containerType")
    const loadibility = watch("loadibility")
    const cbm = watch("cbm")
    const totalweight = watch("totalweight")
    useEffect(()=>{
        if(cbm!=cargoStore.totals.totTmpTotalVolume){
            setValue("cbm",cargoStore.totals.totTmpTotalVolume)
        }
        if(totalweight!=cargoStore.totals.totTmpTotalWeight){
            setValue("totalweight",cargoStore.totals.totTmpTotalWeight)
        }
    },[cargoStore.totals])

    useEffect(()=>{
        if(Number(cbm)>0 && cbm!=cargoStore.totals.totTmpTotalVolume){
            cargoStore.totals.totTmpTotalVolume= Number(cbm)
        }
    },[cbm])

    useEffect(()=>{
        if(Number(totalweight)>0 && totalweight!=cargoStore.totals.totTmpTotalWeight){
            cargoStore.totals.totTmpTotalWeight= Number(totalweight)
        }
    },[totalweight])

    const setContainerType = (v)=>{
        setValue('containerType',v)
        setCostrecord(v,0,true)
    }

    useEffect(()=>{
        setCostrecord(containerType,loadibility)
    },[loadibility])

    const getcostrecord = (v, l = 0, ct = false, costRecords) => {
        const source = costRecords || fetchedCostRecords || editrequestapprovalStore.quote?.costRecords
        if (source != undefined && Object.keys(source).length > 0) {
            let cr = source;

            const sections = [
                { key: 'originCharges', category: 'ORIGIN', prefix: 'Origin Charges' },
                { key: 'originInlandHaulage', category: 'ORIGIN', prefix: 'Origin Inland Haulage', defaultDesc: 'Origin Inland Haulage' },
                { key: 'oceanFreight', category: 'FREIGHT', prefix: 'Ocean Freight', defaultDesc: 'Ocean Freight' },
                { key: 'oceanFreight2ndLeg', category: 'FREIGHT', prefix: 'Ocean Freight 2nd Leg', defaultDesc: 'Ocean Freight 2nd Leg' },
                { key: 'destinationChargeCIF', category: 'DESTINATION', prefix: 'Destination Charges' },
                { key: 'destinationChargeFairTerms', category: 'DESTINATION', prefix: 'Destination Charges' },
                { key: 'destinationCFSCharges', category: 'DESTINATION', prefix: 'Destination CFS Charges', defaultDesc: 'Destination CFS Charges' },
                { key: 'destinationChargeReworking', category: 'DESTINATION', prefix: 'Destination Charges Reworking', defaultDesc: 'Destination Charges Reworking' },
                { key: 'destinationInlandHaulage', category: 'DESTINATION', prefix: 'Destination Inland Haulage', defaultDesc: 'Destination Inland Haulage' }
            ];

            // Resolve initial loadibility and containerType if not passed (l == 0 or ct == true)
            if (l == 0 || ct == true) {
                for (const sec of sections) {
                    const list = cr[sec.key];
                    if (Array.isArray(list) && list.length > 0) {
                        const found = list.find(item => (Number(item.l20) > 0 || Number(item.l40) > 0));
                        if (found) {
                            if (v == 20 && Number(found.l20) > 0) {
                                l = Number(found.l20);
                            } else if (v == 40 && Number(found.l40) > 0) {
                                l = Number(found.l40);
                            } else if (Number(found.l40) > 0 && (!found.l20 || Number(found.l20) === 0)) {
                                l = Number(found.l40);
                                v = 40;
                                if (ct == true) setValue('containerType', 40);
                            } else if (Number(found.l20) > 0) {
                                l = Number(found.l20);
                                v = 20;
                                if (ct == true) setValue('containerType', 20);
                            }
                            if (ct == true && l > 0) {
                                setValue('loadibility', l);
                            }
                            break;
                        }
                    }
                }
            }

            const result = [];

            // Map all defined sections
            sections.forEach(sec => {
                const list = cr[sec.key];
                if (Array.isArray(list) && list.length > 0) {
                    list.forEach(item => {
                        let value = null;
                        const hasContainerRate = (
                            item.chargeHead === "ORIGIN CHARGES" ||
                            Number(item.r20) > 0 ||
                            Number(item.r40) > 0 ||
                            Number(item.l20) > 0 ||
                            Number(item.l40) > 0
                        );

                        if (hasContainerRate) {
                            const itemLoad = l > 0 ? l : (v == 40 ? (Number(item.l40) || Number(item.l20)) : (Number(item.l20) || Number(item.l40)));
                            if (itemLoad > 0) {
                                let r = 0;
                                if (v == 20) {
                                    r = (Number(item.r20) > 0) ? Number(item.r20) : (Number(item.r40) > 0 ? Number(item.r40) : 0);
                                } else if (v == 40) {
                                    r = (Number(item.r40) > 0) ? Number(item.r40) : (Number(item.r20) > 0 ? Number(item.r20) : 0);
                                }
                                if (r > 0) {
                                    value = r / itemLoad;
                                    value = Number.isInteger(value) ? +value.toFixed(0) : +value.toFixed(2);
                                }
                            }
                        }

                        let desc = '';
                        const head = (item.chargeHead || '').trim();
                        if (!head) {
                            desc = sec.defaultDesc || sec.prefix;
                        } else if (head === "ORIGIN CHARGES") {
                            desc = head;
                        } else if (sec.defaultDesc && head.toLowerCase() === sec.defaultDesc.toLowerCase()) {
                            desc = sec.defaultDesc;
                        } else if (head.toLowerCase().startsWith(sec.prefix.toLowerCase())) {
                            desc = head;
                        } else {
                            desc = `${sec.prefix} - ${head}`;
                        }

                        const curr = (item.currency && item.currency.trim()) ? item.currency.trim() : (sec.category === 'ORIGIN' ? 'INR' : 'USD');

                        result.push({
                            chargeDescription: desc,
                            isIncluded: "Yes",
                            perShipment: Number(item.perShipment) || 0,
                            currency: curr,
                            minimum: value != null ? value : (Number(item.min) || Number(item.minimum) || 0),
                            perCBM: value != null ? value : (Number(item.cbm) || Number(item.perCBM) || 0),
                            perTon: value != null ? value : (Number(item.ton) || Number(item.perTon) || 0),
                            maximum: Number(item.max) || Number(item.maximum) || 0,
                            total: 0,
                            category: sec.category,
                            onaccount: "On Your Account",
                            id: result.length + 1,
                            hasContainerRate: hasContainerRate
                        });
                    });
                }
            });

            // Handle any extra array properties in cr
            const knownKeys = new Set(sections.map(s => s.key));
            Object.keys(cr).forEach(k => {
                if (!knownKeys.has(k) && Array.isArray(cr[k]) && cr[k].length > 0) {
                    let cat = 'DESTINATION';
                    const lowerK = k.toLowerCase();
                    if (lowerK.includes('origin')) cat = 'ORIGIN';
                    else if (lowerK.includes('freight') || lowerK.includes('ocean')) cat = 'FREIGHT';

                    cr[k].forEach(item => {
                        let desc = item.chargeHead || k;
                        result.push({
                            chargeDescription: desc,
                            isIncluded: "Yes",
                            perShipment: Number(item.perShipment) || 0,
                            currency: item.currency || 'USD',
                            minimum: Number(item.min) || Number(item.minimum) || 0,
                            perCBM: Number(item.cbm) || Number(item.perCBM) || 0,
                            perTon: Number(item.ton) || Number(item.perTon) || 0,
                            maximum: Number(item.max) || Number(item.maximum) || 0,
                            total: 0,
                            category: cat,
                            onaccount: "On Your Account",
                            id: result.length + 1,
                            hasContainerRate: false
                        });
                    });
                }
            });

            // Ensure baseline categories exist if result has charges
            if (result.length > 0) {
                let ORIGIN = false;
                let FREIGHT = false;
                let DESTINATION = false;
                result.forEach(e => {
                    if (e.category === "ORIGIN") ORIGIN = true;
                    if (e.category === "FREIGHT") FREIGHT = true;
                    if (e.category === "DESTINATION") DESTINATION = true;
                });

                if (!ORIGIN) {
                    result.push({
                        id: result.length + 1,
                        category: 'ORIGIN',
                        chargeDescription: 'Origin Charges',
                        currency: 'INR',
                        perShipment: 0,
                        perCBM: 0,
                        perTon: 0,
                        minimum: 0,
                        maximum: 0,
                        total: 0,
                        onaccount: "On Your Account",
                    });
                }
                if (!FREIGHT) {
                    result.push({
                        id: result.length + 1,
                        category: 'FREIGHT',
                        chargeDescription: 'Ocean Freight',
                        currency: 'USD',
                        perShipment: 0,
                        perCBM: 0,
                        perTon: 0,
                        minimum: 0,
                        maximum: 0,
                        total: 0,
                        onaccount: "On Your Account",
                    });
                }
                if (!DESTINATION) {
                    result.push({
                        id: result.length + 1,
                        category: 'DESTINATION',
                        chargeDescription: 'Destination Charges',
                        currency: 'USD',
                        perShipment: 0,
                        perCBM: 0,
                        perTon: 0,
                        minimum: 0,
                        maximum: 0,
                        total: 0,
                        onaccount: "On Your Account",
                    });
                }

                result.forEach((r, idx) => {
                    r.id = idx + 1;
                });
            }

            return result;
        }
        return [];
    };

    const checkeditload = (cr1, cr2) => {
        if (!cr1 || !cr2 || cr1.length === 0 || cr2.length === 0) {
            setEditload(false);
            return;
        }
        let dynamicCharges = cr1.filter(r => r.hasContainerRate || r.chargeDescription === 'ORIGIN CHARGES');
        if (dynamicCharges.length === 0) {
            setEditload(false);
            return;
        }
        let l = dynamicCharges.some(r =>
            cr2.some(e =>
                e.chargeDescription === r.chargeDescription &&
                r.perShipment === e.perShipment &&
                r.currency === e.currency &&
                r.minimum === e.minimum &&
                r.perCBM === e.perCBM &&
                r.perTon === e.perTon
            )
        );
        setEditload(l);
    };

    const setCostrecord = (v, l = 0, ct = false) => {
        if (editload && watchedcostrecord && watchedcostrecord.length > 0) {
            const result = getcostrecord(v, l, ct);
            let k = watchedcostrecord.map(e => {
                const updated = result.find(r => r.chargeDescription === e.chargeDescription && (r.hasContainerRate || r.chargeDescription === 'ORIGIN CHARGES'));
                if (updated) {
                    return {
                        ...e,
                        minimum: updated.minimum,
                        perCBM: updated.perCBM,
                        perTon: updated.perTon,
                        perShipment: updated.perShipment
                    };
                }
                return e;
            });
            if (!isEqual(watchedcostrecord, k)) {
                setValue("costrecord", k);
            }
        }
    };

    useEffect(()=>{
        if(containerType==undefined || containerType.toString().trim().length==0){
            setContainerType(20)
        }
    },[containerType])

    const req = useMemo(() => {
          let limits = []
          let lobj = {}
          let eobj = {}
          let err = []
          let totals = {}
          let pl=0
          let editloadCheck = false
          if(editrequestapprovalStore.quote!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
            let l = JSON.parse(JSON.stringify(editrequestapprovalStore.quote?.quoteData))
            l['orginalchargesList'] = []
            l['chargesList'] = []
            l['shipperchargesList'] = []
            l['consigneechargesList'] = []
            l['pkb'] = []
            l['rebate'] = []
            if(watchedList.length>0){
                l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
            }
            if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
                l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
                l['pkb'][0]['id'] = 1
                l['pkb'][0]['isIncluded'] = 'Yes'
            }
            if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
                l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
                l['rebate'][0]['id'] = 1
                l['rebate'][0]['isIncluded'] = 'Yes'
            }
            let z = l['orginalchargesList']
            for (let i = 0; i < z.length; i++) {
                z[i]['id'] = i+1
                if(z[i]['total']!=0){
                    z[i]['isIncluded'] = 'Yes'
                    if(z[i]['onaccount']=='On Your Account'){
                        l['chargesList'].push(z[i])
                    } 
                    if(z[i]['onaccount']=="Shipper's Account"){
                        l['shipperchargesList'].push(z[i])
                    }
                    if(z[i]['onaccount']=="Consignee's Account"){
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
            l['orginalchargesList'] = z
            let k = new QuoteCalcV2(l).recalc()
            l['quoteValue'] = k.quoteValue
            l['quoteValueUSD'] = k.quoteValueUSD
            if(k.quoteValue!=0){
                // setEditload must not run during render (it loops); the effect below does the check
                if(watchedcostrecord!=undefined && watchedcostrecord.length>0 && containerType!=undefined && loadibility!=undefined){
                    editloadCheck = true
                }
                const getCategoryTotals = (list) => {
                    return list.reduce((acc, item) => {
                        const rate = configStore.getExchangeRate(item.currency) || 1;
                        const total = rate * (item.tmptotal || 0);
                        acc[item.category] = (acc[item.category] || 0) + total;
                        return acc;
                    }, {});
                };
                let ctotal = getCategoryTotals(watchedcostrecord)
                let rtotal = getCategoryTotals(l['orginalchargesList'])

                const categories = new Set([
                ...Object.keys(ctotal),
                ...Object.keys(rtotal)
                ]);

                categories.forEach(category => {
                    totals[category] = {
                        Cost: ctotal[category] || 0,
                        Revised: rtotal[category] || 0,
                        "P/L":(rtotal[category] || 0)-(ctotal[category] || 0)
                    };
                });
                Object.keys(totals).map(e=>{
                    pl = pl+totals[e]['P/L']
                })
                let t1 = Utils.getTotal(watchedoriginalList)+Utils.getTotal(watchedoriginalRebate)+Utils.getTotal(watchedoriginalPkb)
                let t2 = Utils.getTmpTotal(l['orginalchargesList'])
                let t3 = Utils.getTmpTotal(l['pkb'])
                let t4 = Utils.getTmpTotal(l['rebate'])
                t2 = t2+t4+t3
                conditions.map(e=>{
                    if(e.reductionPercentage!=undefined){
                        if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                            if(lobj[JSON.stringify(e)]==undefined){
                            lobj[JSON.stringify(e)] = 1
                            limits.push(e)
                            }
                            let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                            if(eobj[JSON.stringify(e2)]==undefined){
                            eobj[JSON.stringify(e2)] = 1
                            err.push(e2)
                            }
                        }
                    }
                    if(e.reductionValue!=undefined){
                        let v = configStore.getExchangeRate(e.reductionValueCurrency)
                        let t5 = t1/v
                        let t6 = t2/v
                        let t7 = t5-e.reductionValue
                        if(t7>t6){
                            let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                            if(lobj[JSON.stringify(e)]==undefined){
                                lobj[JSON.stringify(e)] = 1
                                limits.push(e)
                            }
                            if(eobj[JSON.stringify(e2)]==undefined){
                                eobj[JSON.stringify(e2)] = 1
                                err.push(e2)
                            }
                        }
                        // l['orginalchargesList'].map(e1=>{
                        //     if(e1['currency']==e.reductionValueCurrency){
                        //         if(e1['total']<e.reductionValue){
                        //             if(lobj[JSON.stringify(e)]==undefined){
                        //             lobj[JSON.stringify(e)] = 1
                        //             limits.push(e)
                        //             }
                        //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                        //             if(eobj[JSON.stringify(e2)]==undefined){
                        //             eobj[JSON.stringify(e2)] = 1
                        //             err.push(e2)
                        //             }
                        //         }
                        //     }
                        // })
                    }
                })
                if(err.length==0 && t1!=t2 && conditions.length==0){
                    err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
                }
            }
          }
          return { limits, err, totals,pl,editloadCheck };
        }, [watchedList,watchedPkb,watchedRebate,conditions,originallist,watchedoriginalList,watchedoriginalRebate,watchedoriginalPkb,watchedcostrecord]);

    useEffect(()=>{
        if(req.editloadCheck){
            checkeditload(getcostrecord(containerType,loadibility),watchedcostrecord)
        }
    },[req, containerType, loadibility, fetchedCostRecords])

    useEffect(()=>{
        if(editrequestapprovalStore.quote?.quoteData && JSON.stringify(contractsStore.current)!=JSON.stringify(editrequestapprovalStore.quote?.quoteData)){
            contractsStore.current = JSON.parse(JSON.stringify(editrequestapprovalStore.quote?.quoteData))
        }
    },[JSON.stringify(editrequestapprovalStore.quote)])

    const save = ()=>{
        let limits = []
        let lobj = {}
        let eobj = {}
        let err = []
        if(editrequestapprovalStore.quote!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
            let l = JSON.parse(JSON.stringify(editrequestapprovalStore.quote?.quoteData))
            chargesBookingValidationStore.isNew = false
            let kz = true
            if (watchedList &&
            !watchedList.every((charge, index) =>
                Object.keys(charge).every((chargeKey) =>
                chargesBookingValidationStore.isValidChargelclform(chargeKey, index,watchedList)
                )
            )
            ) {
            kz = false
            }
            if(!kz){
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
            l['orginalchargesList'] = []
            l['chargesList'] = []
            l['shipperchargesList'] = []
            l['consigneechargesList'] = []
            l['pkb'] = []
            l['rebate'] = []
            if(watchedList.length>0){
                l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
            }
            if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
                l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
                l['pkb'][0]['id'] = 1
                l['pkb'][0]['isIncluded'] = 'Yes'
            }
            if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
                l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
                l['rebate'][0]['id'] = 1
                l['rebate'][0]['isIncluded'] = 'Yes'
            }
            let z = l['orginalchargesList']
            for (let i = 0; i < z.length; i++) {
                z[i]['id'] = i+1
                if(z[i]['total']!=0){
                    z[i]['isIncluded'] = 'Yes'
                    if(z[i]['onaccount']=='On Your Account'){
                        l['chargesList'].push(z[i])
                    } 
                    if(z[i]['onaccount']=="Shipper's Account"){
                        l['shipperchargesList'].push(z[i])
                    }
                    if(z[i]['onaccount']=="Consignee's Account"){
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
            l['orginalchargesList'] = z
            let k = new QuoteCalcV2(l).recalc()
            l['quoteValue'] = k.quoteValue
            l['quoteValueUSD'] = k.quoteValueUSD
            if(k.quoteValue!=0){
                let t1 = Utils.getTotal(originallist)+Utils.getTotal(originalrebatelist)+Utils.getTotal(originalpkblist)
                let t2 = Utils.getTotal(l['orginalchargesList'])
                let t3 = Utils.getTotal(l['pkb'])
                let t4 = Utils.getTotal(l['rebate'])
                t2 = t2+t4+t3
                conditions.map(e=>{
                    if(e.reductionPercentage!=undefined){
                        if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                            if(lobj[JSON.stringify(e)]==undefined){
                            lobj[JSON.stringify(e)] = 1
                            limits.push(e)
                            }
                            let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                            if(eobj[JSON.stringify(e2)]==undefined){
                            eobj[JSON.stringify(e2)] = 1
                            err.push(e2)
                            }
                        }
                    }
                    if(e.reductionValue!=undefined){
                        let v = configStore.getExchangeRate(e.reductionValueCurrency)
                        let t5 = t1/v
                        let t6 = t2/v
                        let t7 = t5-e.reductionValue
                        if(t7>t6){
                            let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                            if(lobj[JSON.stringify(e)]==undefined){
                                lobj[JSON.stringify(e)] = 1
                                limits.push(e)
                            }
                            if(eobj[JSON.stringify(e2)]==undefined){
                                eobj[JSON.stringify(e2)] = 1
                                err.push(e2)
                            }
                        }
                        // l['orginalchargesList'].map(e1=>{
                        //     if(e1['currency']==e.reductionValueCurrency){
                        //         if(e1['total']<e.reductionValue){
                        //             if(lobj[JSON.stringify(e)]==undefined){
                        //             lobj[JSON.stringify(e)] = 1
                        //             limits.push(e)
                        //             }
                        //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                        //             if(eobj[JSON.stringify(e2)]==undefined){
                        //             eobj[JSON.stringify(e2)] = 1
                        //             err.push(e2)
                        //             }
                        //         }
                        //     }
                        // })
                    }
                })
                if(err.length==0 && t1!=t2 && conditions.length==0){
                    err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
                }
                const removemutitc = (l) =>{
                    l = l.split('\n')
                    let k = []
                    for (let j = 0; j < l.length; j++) {
                    if(l[j].trim().length>0 && l[j].toLowerCase().indexOf('rate is applicable only for cargo till')==-1){
                        k.push(l[j])
                    }
                    }
                    if(k.length>0){
                    return k.join('\n')
                    }else{
                    return ""
                    }
                }
                let customTC = editrequestapprovalStore.editquote['quoteData']['customTC']
                customTC = removemutitc(customTC)
                if(cargoStore.totals.totTotalVolume!=cargoStore.totals.totTmpTotalVolume){
                    customTC = customTC+(customTC.length>0?'\n':"")+`This rate is applicable only for cargo till ${cargoStore.totals.totTmpTotalVolume} CBM`
                }
                if(cargoStore.totals.totTotalWeight!=cargoStore.totals.totTmpTotalWeight){
                    customTC = customTC+(customTC.length>0?'\n':"")+`This rate is applicable only for cargo till ${cargoStore.totals.totTmpTotalWeight} Kgs`
                }
                editrequestapprovalStore.editquote['quoteData']['customTC'] = customTC
                editrequestapprovalStore.editquote['totalnewrevisedcharge'] = t2
                editrequestapprovalStore.editquote['limitdetails'] = limits
                editrequestapprovalStore.editquote['limiterrors'] = err
                editrequestapprovalStore.editquote['mrg_chargesList'] = l['orginalchargesList']
                editrequestapprovalStore.editquote['pkb'] = l['pkb']
                editrequestapprovalStore.editquote['rebate'] = l['rebate']
                editrequestapprovalStore.editquote['quoteData']['quoteValue'] = l['pkb']
                editrequestapprovalStore.editquote['quoteData']['quoteValueUSD'] = l['rebate']
                editrequestapprovalStore.editquote['costDocuments'] = JSON.parse(JSON.stringify(editrequestapprovalStore.quote.costDocuments))
                editrequestapprovalStore.editquote['containerType'] = containerType
                editrequestapprovalStore.editquote['loadibility'] = loadibility
                editrequestapprovalStore.editquote['customCostRecord'] = watchedcostrecord
                if (fetchedCostRecords) editrequestapprovalStore.editquote['costRecords'] = fetchedCostRecords
                editrequestapprovalStore.editquote['quoteData']['aiChargeHistory'] = getAiHistory("rateRequestApproval")
                setActionmodal(true)
            }
        }
    }
    
    useEffect(()=>{
        if(editrequestapprovalStore.quote?.conditionsPayload){
            const callback = (data) =>{
                    setConditions(data.data)
                    setShow1(true)
                    loader.hide()
                }
                loader.show()
                Api.apiGetconditionslist(editrequestapprovalStore.quote.conditionsPayload,callback)
        }
    },[])


    useEffect(()=>{
        if(!show && editrequestapprovalStore.quote?.quoteData && JSON.stringify(editrequestapprovalStore.quote?.quoteData)==JSON.stringify(contractsStore.current)){
        if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(editrequestapprovalStore.quote.cargoList)){
            cargoStore.cargoList = JSON.parse(JSON.stringify(editrequestapprovalStore.quote.cargoList))
        }
        if(editrequestapprovalStore.quote.costDocuments==undefined){
            editrequestapprovalStore.quote.costDocuments = []
        }
        cargoStore.calculateCargoTotals()
        let c = []
        let k = []
        if(editrequestapprovalStore.quote.chargesList!=undefined){
            c = editrequestapprovalStore.quote.chargesList
        }
        if(editrequestapprovalStore.quote.mrg_chargesList!=undefined){
            k = editrequestapprovalStore.quote.mrg_chargesList
        }
        if(editrequestapprovalStore.quote.nomrg_rebate!=undefined){
            if(JSON.stringify(originalrebatelist)!=JSON.stringify(editrequestapprovalStore.quote.nomrg_rebate)){
                setValue('originallistrebate',JSON.parse(JSON.stringify(editrequestapprovalStore.quote.nomrg_rebate)))
                setOriginalrebatelist(JSON.parse(JSON.stringify(editrequestapprovalStore.quote.nomrg_rebate)))
            }
        }
        if(editrequestapprovalStore.quote.nomrg_pkb!=undefined){
            if(JSON.stringify(originalpkblist)!=JSON.stringify(editrequestapprovalStore.quote.nomrg_pkb)){
                setValue('originallistpkb',JSON.parse(JSON.stringify(editrequestapprovalStore.quote.nomrg_pkb)))
                setOriginalrebatelist(JSON.parse(JSON.stringify(editrequestapprovalStore.quote.nomrg_pkb)))
            }
        }
        chargesBookingValidationStore.isNew = true
        setValue('initialLength',k.length)
        setValue('list',JSON.parse(JSON.stringify(k)))
            let type = editrequestapprovalStore.quote.quoteData.shipmentType
            let scope = editrequestapprovalStore.quote.quoteData.shipmentScope
            const data1 = chargesData1[type.toLowerCase()+scope.toLowerCase()];
            if(editrequestapprovalStore.quote.rebate==undefined || editrequestapprovalStore.quote.rebate.length==0){
                setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
            }else{
                setValue('rebate',JSON.parse(JSON.stringify(editrequestapprovalStore.quote.rebate)))
            }
            if(editrequestapprovalStore.quote.pkb==undefined || editrequestapprovalStore.quote.pkb.length==0){
                setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
            }else{
                setValue('pkb',JSON.parse(JSON.stringify(editrequestapprovalStore.quote.pkb)))
            }
            setValue('originallistlist',c)
            setOriginallist(c)
            let ct = 0
            if(editrequestapprovalStore.quote.containerType != undefined){
                ct = editrequestapprovalStore.quote.containerType
            }
            let lt = 0
            if(editrequestapprovalStore.quote.loadibility != undefined){
                lt = editrequestapprovalStore.quote.loadibility
            }
            if((editrequestapprovalStore.quote.customCostRecord == undefined || editrequestapprovalStore.quote.customCostRecord.length==0) && (editrequestapprovalStore.quote.costRecords == undefined || Object.keys(editrequestapprovalStore.quote.costRecords).length==0)){
                setValue("costrecord",data1.preList)
            }
            if(editrequestapprovalStore.quote.customCostRecord != undefined && editrequestapprovalStore.quote.customCostRecord.length>0){
                setValue("costrecord",editrequestapprovalStore.quote.customCostRecord)
            }else if (editrequestapprovalStore.quote.costRecords != undefined && Object.keys(editrequestapprovalStore.quote.costRecords).length>0) {
                const result = getcostrecord(ct, lt, true);
                if (result && result.length > 0) {
                    setValue("costrecord", result);
                    setValue("initialLength2", result.length);
                    setEditload(true);
                }
            }
        setShow(true)
        }
    },[JSON.stringify(editrequestapprovalStore.quote),JSON.stringify(contractsStore.current)])

    // Route of this rate request: the saved pricing record first, older fields as fallback
    const costRouteFromQuote = (q) => {
        const pr = q?.pricingRecord || {}
        const qd = q?.quoteData || {}
        const cp = q?.conditionsPayload || {}
        const pick = (...v) => v.find((x) => x !== undefined && x !== null && String(x).trim() !== '')
        // Destination charge heads applied to the route ("Destination Charges - THC" -> "THC")
        const descs = pr.charges ? Object.keys(pr.charges) : (q?.mrg_chargesList || q?.chargesList || []).map((c) => c.chargeDescription)
        const heads = descs
            .map((d) => String(d || ''))
            .map((d) => d.startsWith('Destination Charges - ') ? d.slice('Destination Charges - '.length) : (['ACD', 'DDC'].includes(d) ? d : null))
            .filter(Boolean)
        return {
            set: pick(pr.set, q?.set),
            agent: pick(pr.agent, q?.agent, cp.agent),
            agent2: pick(pr.agent2),
            por: pick(pr.por, qd.portOfReceipt),
            pol: pick(pr.pol, cp.pol, qd.portOfLoading),
            rw: pick(pr.rep, qd.reworkingPort),
            pod: pick(pr.pod, cp.pod, qd.portOfDischarge),
            fpod: pick(pr.fpod, cp.fpod, qd.finalPlaceOfDelivery),
            chargeHeads: heads.length > 0 ? [...new Set(heads)] : undefined,
        }
    }

    const getCost = async () => {
        const route = costRouteFromQuote(editrequestapprovalStore.quote)
        setCostLoading(true)
        try {
            const res = await MonApi.apost(`${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/lclcostpricing/lclexport`, route)
            if (res?.error) return configStore.setModalMessage(`Unable to get cost: ${res.error}`)
            const found = Object.values(res?.counts || {}).reduce((a, b) => a + b, 0)
            if (!found) {
                const r = res?.route || {}
                const searched = `Set ${r.set || '-'}, Agent ${r.agent || '-'}, ${[r.por, r.pol, r.pod, r.fpod].map((p) => p || '-').join(' → ')}`
                const missing = res?.missing?.length ? ` Missing on this rate request: ${res.missing.join(', ')}.` : ''
                const contractRate = !(Number(r.set) >= 45 && Number(r.set) <= 59)
                    ? ' LCL export cost exists only for pricing sets 45–59; this rate request uses a different rate set (e.g. a contract rate).'
                    : ''
                return configStore.setModalMessage(`No cost records found for this route (${searched}).${missing}${contractRate}`)
            }
            // Only finite numbers: a NaN rate makes the table's totals recalculate forever
            const num = (x) => (Number.isFinite(Number(x)) ? Number(x) : 0)
            const rows = getcostrecord(containerType, 0, true, res.costRecords).map((r, i) => ({
                ...r,
                id: i + 1,
                perCBM: num(r.perCBM),
                perTon: num(r.perTon),
                minimum: num(r.minimum),
                maximum: num(r.maximum),
                perShipment: num(r.perShipment),
                total: 0,
                tmptotal: 0,
            }))
            setFetchedCostRecords(res.costRecords)
            setValue("costrecord", rows)
            setValue("initialLength2", rows.length)
            setEditload(true)
            if (res.missing?.length) configStore.setModalMessage(`Cost loaded. Some route details are missing (${res.missing.join(', ')}), so those charges may be incomplete.`)
        } catch (e) {
            configStore.setModalMessage(`Unable to get cost: ${e?.message || e}`)
        } finally {
            setCostLoading(false)
        }
    }

    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }


    const getlcv = (ob,key)=>{
        if(ob!=undefined){
            if(ob[key]!=undefined){
                return ob[key]
            }
        }
        return "-"
    }


    return (<>{ show &&<>
    {
                            actionmodal && <div className='modal is-active'>
                            <div className="modal-background"></div>
                            <div className="modal-card">
                                <section className="modal-card-body" >
                                    <button className="delete" style={{ float: 'right' }} onClick={() => { setActionmodal(false) }}></button>
                                     <p>
                                        Are you sure you want to approve this?
                                     </p>
                                     <p>
                                        Please confirm to proceed.
                                     </p>
                                     <textarea class={"textarea is-info"} value={remarks}   placeholder="Enter your remarks. (Optional)" rows={5} onChange={(e) => {
                                setRemarks(e.target.value)
                            }}></textarea>
                                     
                                     <hr />
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 10 }}>
                                <div className="control">
                                    <button class="button is-danger" onClick={() => {
                                        setActionmodal(false)
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                                <div className="control">
                                    <button className="button"
                                     style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                        onClick={async (e) => {
                                            loader.show()
                                            console.log(editrequestapprovalStore.editquote)
                                            const callback = (d)=>{
                                                loader.hide()
                                                setOpenChargeModel(false)
                                                setActionmodal(false)
                                                configStore.setModalMessage("Approved successfully.")
                                                AgmodalStore.pageVisible = false;
                                                AgmodalStore.apiCall = true;
                                            }
                                            editrequestapprovalStore.editquote.remarks = remarks
                                            Api.setRequestupdateapprove(editrequestapprovalStore.editquote,callback)
                                        }}>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                                </section>
                            </div>
                        </div>
                        }
    {/* {
                        req.err.length>0 && <>
                        <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Charge Limit"/>
                                    {req.limits.length>0 && <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    <thead>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Origin Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Destination Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POL</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POD</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Rate Type</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Percentage</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                req.limits.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"originCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"destinationCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pol")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pod")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"rateType")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionPercentage")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValue")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValueCurrency")}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>}

                        <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    
                        <tbody>
                            {
                                req.err.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{e}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>

                                    </Card>
                                    <hr />
                        </>
                    } */}
                    {Object.keys(req.totals).length>0 &&<> <Card>
                            <table style={{ width:"100%"}}>
                    <thead>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>Categories</th>
                            <th colSpan={2} style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>Revised</th>
                            <th colSpan={2} style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>Cost</th>
                            <th colSpan={2} style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>Profit/Loss</th>
                        </tr>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}></th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>INR</th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>USD</th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>INR</th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>USD</th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>INR</th>
                            <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign:"center"}}>USD</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                Object.keys(req.totals).map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{e}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['Revised'],"INR")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['Revised']/configStore.getExchangeRate('USD'),"USD")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['Cost'],"INR")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['Cost']/configStore.getExchangeRate('USD'),"USD")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['P/L'],"INR")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.totals[e]['P/L']/configStore.getExchangeRate('USD'),"USD")}</td>
                                    </tr>
                                })
                            }
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>Total</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.pl,"INR")}</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign:"center"}}>{Utils.N2(req.pl/configStore.getExchangeRate('USD'),"USD")}</td>
                                    </tr>
                        </tbody>
                        </table>
                            </Card><hr /></>}

                            <Card>
                                          <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                                            <thead>
                                              <tr>
                                                <th style={{ width: "16rem" }}>Required Documents</th>
                                                <th>Document Uploaded</th>
                                                <th style={{ width: "12rem" }}></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr id="cwf5">
                                                <td>Cost Documents</td>
                                                <td>
                                                  {editrequestapprovalStore.quote.costDocuments &&
                                                    editrequestapprovalStore.quote.costDocuments
                                                      .map(renderLink)
                                                      .map((link, i) => (
                                                        <>
                                                          <p>
                                                            {link}
                                                            <span
                                                              className="icon has-text-danger"
                                                              style={{ cursor: "pointer" }}
                                                              onClick={() => {
                                                                let l = []
        let k = JSON.parse(JSON.stringify(editrequestapprovalStore.quote))
        let a = k.costDocuments
        for (let j = 0; j < a.length; j++) {
            if(j!=i){
                l.push(a[i])
            }
        }
        k.supportingDocuments_list = l
        editrequestapprovalStore.quote = k
                                                              }}
                                                            >
                                                              <i className="fas fa-trash"></i>
                                                            </span>
                                                          </p>
                                                          <br />
                                                        </>
                                                      ))}
                                                </td>
                                                <td>
                                                  <AgCustomFile
                                                    source="carrierwebform"
                                                    cat={filecat}
                                                    filetype="costDocuments"
                                                    parent="cwf5"
                                                    multi={true}
                                                    callback={(filename) => {
                                                        editrequestapprovalStore.quote.costDocuments.push(filename)
                                                    }}
                                                    withBtn={
                                                      editrequestapprovalStore.quote.costDocuments &&
                                                      editrequestapprovalStore.quote.costDocuments.length > 0
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        
                                      </Card><hr />

   <FormProvider {...charges}>    
    <div className="columns is-vcentered is-multiline qoutecard">
        {
            (watchedcostrecord!=undefined && watchedcostrecord.length>0)?<>
            <div className="column is-3">
                <AgSelectNewCH
                isDisabled={{disabled:!editload}}
                  label="Container Type"
                  name="containerType"
                  placeholder={"Container Type"}
                  dataList={[
                    { label: 20, value: 20 },
                    { label: 40, value: 40 },
                  ]}
                  callback={(e1) => setContainerType(e1)}
                  value={formValues["containerType"]}
                  size="small"
              fullWidth
                />
              </div>
              <div className="column is-3">
                          <LabeledTextField
                          disabled={!editload}
                          labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
                            placeholder="Loadibility"
                            label="Loadibility"
                            control={control}
                            name="loadibility"
                            type="number"
                            size="small"
                            fullWidth
                          />
                        </div>
            </>:<></>
        }
        <div className="column is-3">
                          <LabeledTextField
                          labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
                            placeholder="CBM"
                            label="CBM"
                            control={control}
                            name="cbm"
                            type="number"
                            size="small"
                            fullWidth
                          />
                        </div>
                        <div className="column is-3">
                          <LabeledTextField
                          labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
                            placeholder="Total Weight(kgs)"
                            label="Total Weight(kgs)"
                            control={control}
                            name="totalweight"
                            type="number"
                            size="small"
                            fullWidth
                          />
                        </div>
        </div>         
<div class="columns is-multiline">
    
  <div class="column is-4">
    {editrequestapprovalStore.quote?.quoteData?.shipmentType?.toUpperCase().includes('LCL') && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "6px" }}>
            <button
                type="button"
                className={`button is-small ${costLoading ? 'is-loading' : ''}`}
                style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff" }}
                disabled={costLoading}
                title="Fetch the latest cost for this route from pricing and fill the Cost Details table"
                onClick={getCost}
            >
                Get Cost
            </button>
        </div>
    )}
    <LCLChargesCompFrom IL={"initialLength2"} form={charges} oyahide={true} listkey={"costrecord"} aiHistory={{ scope: "rateRequestApproval" }} contract={editrequestapprovalStore.quote?.quoteData} heading={"Cost Details"} tmptotal={true}/>
    <LCLChargesCompFrom form={charges} oyahide={true} listkey={"originallistlist"} contract={editrequestapprovalStore.quote?.quoteData} isDisable={true} heading={"Charge Details"} tmptotal={true}/>
    {originalrebatelist.length>0 && <LCLChargesCompFrom form={charges} listkey={"originallistrebate"} hide={true} isDisable={true} contract={editrequestapprovalStore.quote?.quoteData} tmptotal={true}/>}
    {originalpkblist.length>0 && <LCLChargesCompFrom form={charges} listkey={"originalpkbrebate"} hide={true} isDisable={true} contract={editrequestapprovalStore.quote?.quoteData} tmptotal={true}/>}
  </div>
  <div class="column is-8">

    <LCLChargesCompFrom form={charges} listkey={"list"} contract={editrequestapprovalStore.quote?.quoteData} heading={"Revised Details"} tmptotal={true} aiHistory={{ scope: "rateRequestApproval" }} />
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.REBATE) && <><hr /><LCLChargesCompFrom form={charges} listkey={"rebate"} hide={true} contract={editrequestapprovalStore.quote?.quoteData} tmptotal={true}/></>}
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.PKB) && <><hr /><LCLChargesCompFrom IL={"initialLength1"} form={charges} listkey={"pkb"} hide={true} contract={editrequestapprovalStore.quote?.quoteData} tmptotal={true}/></>}

</div>  
</div>   
</FormProvider>
    <div className="columns is-vcentered is-multiline">
<div className="column is-12" style={{textAlign:"right"}}>
<div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.APPROVE_REJECT) && <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          save()
                        }}
                      >
                        Approve
                      </button>
                    </div>}
                    <div className="control">
                      <button
                        class="button is-danger"
                        onClick={() => {
                          setOpenChargeModel(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
</div></div>
           
            
    </>}</>)
}


